import React, { useCallback, useState } from 'react';
import { Table, Space, Button, Popconfirm } from 'antd';
import { TableWrapper } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import { FileExcelOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';

interface FormItemProps {
  closeList: any[] | undefined;  
  onCellClick: (idx) => void;
}

const CLOSINGTable = ({closeList, onCellClick}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const columns: ColumnsType<any> = [
    {
      title: '번호',
      dataIndex: 'accounting_idx',
      key: 'accounting_idx',
      width: '50px',
      align: 'center',
    },  
    {
      title: '상태',
      dataIndex: 'is_close',
      key: 'is_close',
      width: '100px',
      align: 'center',
      render: (is_close, record) => {
        return (
          (is_close && is_close == 'Y') ? '마감' : '해제'
        )
      },
    },   
    {
      title: '등록일',
      dataIndex: 'open_dt',
      key: 'open_dt',
      width: 'auto',
      align: 'center',
    },
    {
      title: '마감일',
      dataIndex: 'close_dt',
      key: 'close_dt',
      width: 'auto',
      align: 'center',
    },    
    {
      title: '매출액',
      dataIndex: 'close_price',
      key: 'close_price',
      width: 'auto',
      align: 'right',      
      render: (price, record) => {
        return (
          (price+record.change_price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )
      }  
    },             
    {
      title: '변동액',
      dataIndex: 'change_price',
      key: 'change_price',
      width: 'auto',
      align: 'right',      
      render: (price, record) => {
        return (
          <a onClick={()=> onCellClick(record.accounting_idx)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
        )
      }  
    },  
    {
      title: '변동건수',
      dataIndex: 'history_cnt',
      key: 'history_cnt',
      width: '100px',
      align: 'right', 
      render: (cnt, record) => {
        return (
          <a onClick={()=> onCellClick(record.accounting_idx)}>{cnt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
        )
      }            
    },                                                 
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
  
  /* ======================================================
  * hooks
  * ====================================================== */
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <TableWrapper isSearch={false} >
        <Table
          tableLayout="fixed"
          dataSource={closeList}
          columns={columns}
          pagination={false}
          bordered
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}
        />
      </TableWrapper>  
    </Space>
  );
};

export default CLOSINGTable;
